import styled from 'styled-components';

export const ContentWrapperStyle = styled.div`
  width: 100%;
  padding-top: 64px;
`;